/**
 * HUB-H — Bandeau accès outils Carlos-only (SEC-01).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowRight } from 'lucide-react';

import { equipeMagasinsUrl } from '../../utils/navigation/hubNavigation';

const LINKS = [
  { to: '/admin/audit', label: 'Audit & sécurité', testId: 'activite-equipe-link-audit' },
  { to: '/admin/database', label: 'Base de données', testId: 'activite-equipe-link-database' },
  { to: equipeMagasinsUrl('users'), label: 'Équipe & magasins', testId: 'activite-equipe-link-equipe-magasins' },
];

export default function ActiviteEquipeAccessBanner() {
  return (
    <div
      className="rounded-xl border p-4 space-y-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid="activite-equipe-access-banner"
    >
      <div className="flex items-start gap-3">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <Shield className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div>
          <p className="text-sm font-semibold text-[var(--rm-white)]">Supervision Carlos-only (SEC-01)</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            Vue synthèse — accès complets sur les écrans administratifs existants. Protections backend inchangées.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2"
            data-testid={link.testId}
          >
            {link.label}
            <ArrowRight className="w-4 h-4" />
          </Link>
        ))}
      </div>
    </div>
  );
}
